export default __webpack_public_path__ + "static/media/related_sample.b327b62a.png";